import React from "react";
import { useUserData } from "../utils/UserData";
import { Link } from "react-router-dom";
import { usePageTitle } from "../utils/usePageTitle";

export default function ContactPage() {
    usePageTitle("Contact");
  const data = useUserData();

  return (
    <main className="max-w-xl mx-auto px-6 py-16 text-slate-800 font-sans text-center space-y-10">
      <h2 className="text-3xl font-semibold text-slate-800">Contact Me</h2>

      <p className="text-slate-600 text-base max-w-md mx-auto">
        Whether you want to collaborate, discuss an idea, or just say hi, feel free to connect through any of the platforms below.
      </p>

      <section className="flex flex-col items-center gap-6">
        <Link
          to={data.socialMedia.github}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full max-w-sm flex items-center justify-center gap-4 p-4 border border-purple-100 rounded-lg hover:bg-purple-50 transition"
        >
          <i className="fa-brands fa-github text-xl text-purple-600"></i>
          <p className="text-base font-medium text-purple-700">GitHub</p>
        </Link>

        <Link
          to={data.socialMedia.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full max-w-sm flex items-center justify-center gap-4 p-4 border border-purple-100 rounded-lg hover:bg-purple-50 transition"
        >
          <i className="fa-brands fa-linkedin-in text-xl text-purple-600"></i>
          <p className="text-base font-medium text-purple-700">LinkedIn</p>
        </Link>

        <Link
          to={`mailto:${data.socialMedia.email}`}
          className="w-full max-w-sm flex items-center justify-center gap-4 p-4 border border-purple-100 rounded-lg hover:bg-purple-50 transition"
        >
          <i className="fa-solid fa-envelope text-xl text-purple-600"></i>
          <p className="text-base font-medium text-purple-700">Send me an email</p>
        </Link>

        <Link
          to={data.socialMedia.devTo}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full max-w-sm flex items-center justify-center gap-4 p-4 border border-purple-100 rounded-lg hover:bg-purple-50 transition"
        >
          <i className="fa-brands fa-dev text-xl text-purple-600"></i>
          <p className="text-base font-medium text-purple-700">Dev Community</p>
        </Link>

        <Link
          to="https://www.npmjs.com/~sarahcssiqueira"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full max-w-sm flex items-center justify-center gap-4 p-4 border border-purple-100 rounded-lg hover:bg-purple-50 transition"
        >
          <i className="fa-brands fa-npm text-xl text-purple-600"></i>
          <p className="text-base font-medium text-purple-700">npm Packages</p>
        </Link>
      </section>
    </main>
  );
}
